<script >
import useModalStyle from './useModalStyle';
import useModalVisable from './useModalVisable';
import { defineAsyncComponent } from 'vue-demi';
const FlowContainer = defineAsyncComponent(() => Promise.resolve(require('@futuweb/fego-render')?.plugins.ComplexComp.Container.Flow));
const __sfc_main = {};
__sfc_main.props = {
  tpl: Object,
  defaultVisible: Number,
  closable: Boolean,
  fixedMask: Boolean,
  fixedMaskColor: String,
  contentBackgroundColor: String,
  frequencyInterval: Number,
  frequencyTimes: Number,
  zIndex: Number,
  lockScroll: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useTeleport,
    usePageType
  } = require('@fegobull/webapi').use;
  const {
    isPC
  } = usePageType();
  const props = __props;
  const emit = __ctx.emit;

  // 将弹窗传送到body下
  useTeleport(document.body);

  // 处理弹窗显示隐藏的逻辑
  const {
    visible,
    openModal,
    closeModal
  } = useModalVisable(props, emit);

  // 处理一些弹窗样式
  const {
    zIndexStyle,
    fixedMaskStyle,
    contentStyle
  } = useModalStyle(props, visible);

  // 对外暴露的方法
  return Object.assign({
    isPC,
    visible,
    closeModal,
    zIndexStyle,
    fixedMaskStyle,
    contentStyle
  }, {
    open: openModal,
    close: closeModal
  });
};
__sfc_main.components = Object.assign({
  FlowContainer
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <transition v-if="visible" name="fade">
        <div
            :class="[
                'stay-modal',
                {
                    pc: isPC
                }
            ]"
            :style="zIndexStyle"
        >
            <div class="stay-modal-dialog" :style="zIndexStyle">
                <div v-if="fixedMask" :style="fixedMaskStyle"></div>
                <div class="stay-modal-dialog-content-center">
                    <a
                        href="javascript:void(0);"
                        class="close j_close_btn"
                        title="关闭"
                        @click="closeModal"
                        v-if="closable"
                    ></a>
                    <div class="act-dialog-content" :style="contentStyle">
                        <FlowContainer v-if="visible" :children="tpl.children"></FlowContainer>
                    </div>
                </div>
            </div>
        </div>
    </transition>
    <div v-else class="empty-holder"></div>
</template>
<style lang="less" scoped>
@import './variable.less';
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.stay-modal {
    position: relative;
    width: 0 !important;
    height: 0 !important;
    overflow: visible !important;
}

.stay-modal-dialog {
    display: block;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: 0 auto;
}

.stay-modal-dialog .stay-modal-dialog-content-center {
    display: block;
    position: absolute;
    box-sizing: border-box;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #000;
    text-align: center;
    margin-top: calc(var(--modal-close-icon-bottom) / 2);
    .act-dialog-content {
        max-height: var(--modal-max-height);
        max-width: var(--modal-max-width);
        border-radius: var(--modal-border-raidus);
        background-color: #fff;
        overflow-y: auto;
        overflow-x: hidden;
    }
}

.stay-modal-dialog-content-center .close {
    display: block;
    width: var(--modal-close-icon-size);
    height: var(--modal-close-icon-size);
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjMuMjUiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuMTUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0zMCAxOEwxOCAzMCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTggMThMMzAgMzAiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 50%;
    position: absolute;
    left: 50%;
    margin-left: calc(var(--modal-close-icon-size) / -2);
    bottom: var(--modal-close-icon-bottom);
}

.empty-holder {
    display: none;
}
</style>
